// combatpro/panels/monsters/MonsterSlots.js
//
// Combat PRO - MonsterSlots (Stage 40: Monster Panel Integration).
//
// Originally a static decomposition of the Active Monster Slots bar. Stage 40
// adds ONE control to this toolbar: the Roll All initiative button, wired to the
// existing context rollInitiativeForAll handler (Stage 39). The legacy button is
// reproduced verbatim (vi-mass-btn, label "Roll Init All", legacy 5686). The
// Active Slots select is intentionally left untouched (slot-count editing is not
// in this stage's scope). No DOM manipulation. No optional chaining. No em dash.
// Do not edit battletracker.html.

import React, { useContext } from 'react';
import { CombatContext } from '../../contexts/CombatContext';

function MonsterSlots() {
  const { state, rollInitiativeForAll, setActiveMonsterCount } = useContext(CombatContext);

  return (
    <div className="vi-active-slots-bar">
      <div className="vi-active-slots-title">Active Monster Slots</div>
      <div className="vi-active-slots-helper">Select how many monster slots are active for this encounter. Only active slots are used for setup, tracking, and combat flow. The name of each selected monster will appear in the tabs below for quick identification.</div>
      <div className="vi-active-slots-control">
        <label className="vi-ctrl-label">Active Slots:</label>
        <select id="activeCombatants" className="vi-select-neutral" value={state.activeMonsterCount} onChange={(e) => setActiveMonsterCount(parseInt(e.target.value, 10))}>
          <option value="1">1</option><option value="2">2</option><option value="3">3</option>
          <option value="4">4</option><option value="5">5</option><option value="6">6</option>
          <option value="7">7</option><option value="8">8</option><option value="9">9</option>
          <option value="10">10</option><option value="11">11</option><option value="12">12</option>
          <option value="13">13</option><option value="14">14</option><option value="15">15</option>
          <option value="16">16</option>
        </select>
        <button className="vi-mass-btn" onClick={rollInitiativeForAll}>🎲 Roll Init All</button>
      </div>
    </div>
  );
}

export default MonsterSlots;
